import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { appSettings } from '@configs/app-settings.config';

const APP_TITLE = appSettings.appTitle || 'Shipping Marketplace';
const SEPARATOR = ' | ';

@Injectable()
export class TitleService {

  /**
   * Uppercase the first character from given string
   */
  static ucFirst(str: string): string {
    if (!str) {
      return str;
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private metaTitle: Title,
  ) { }

  /**
   * Set application title with standard suffix format: `<Page Name> | Shipping Marketplace`
   * If no page title is provided, it sets the title to `Shipping Marketplace`.
   */
  setTitle(pageTitle?: string): void {
    if (pageTitle && pageTitle.trim()) {
      const cleanTitle = pageTitle.trim();
      if (cleanTitle.endsWith(`${SEPARATOR}${APP_TITLE}`) || cleanTitle === APP_TITLE) {
        this.metaTitle.setTitle(cleanTitle);
      } else {
        this.metaTitle.setTitle(`${cleanTitle}${SEPARATOR}${APP_TITLE}`);
      }
    } else {
      this.metaTitle.setTitle(APP_TITLE);
    }
  }

  /**
   * Change the application title on route navigation
   */
  init(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        let route: ActivatedRoute = this.activatedRoute;
        while (route.firstChild) {
          route = route.firstChild;
        }

        // Search for title from leaf up to root in case a leaf route does not specify data.title
        let currentRoute: ActivatedRoute | null = route;
        let title: string | undefined;

        while (currentRoute) {
          if (currentRoute.snapshot?.data && currentRoute.snapshot.data['title']) {
            title = currentRoute.snapshot.data['title'];
            break;
          }
          currentRoute = currentRoute.parent;
        }

        this.setTitle(title);
      });
  }

}

